<template>
    <div class="call-tim" :class="{'ac-bg-gray': ac}">
		<header-component :is-soon="false" img-left="/trocachip/img/setinha-left-preto.svg" img-right="/trocachip/img/access.png" class="header-component"/>
        <div class="call-tim-body">
            <div class="call-tim-informations">
                <img src="../assets/images/call-center.png" alt="Imagem de um telefone" />
                <h4>Ligue para Central de Atendimento TIM</h4>
                <p>Para trocar seu chip, entre em contato através do 1056.</p>
            </div>
            <div class="call-tim-button">
                <button
                    class="btn btn-primary"
                    :class="{
                        'ac-color-black': ac,
                        'ac-border-yellow': ac,
                        'ac-bg-yellow': ac,
                    }"
                    @click.prevent="next"
                >
                    Ligar para TIM
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import HeaderComponent from '@/components/HeaderComponent';
import trackEvent from '@/services/trackEvent';

export default {
    name: 'Welcome',
	components: {
		HeaderComponent,
	},
    data() {
        return {
            isLoading: false,
            retirado: false,
        }
    },
    computed: {
        ...mapState({
            ac: state => state.ac,
            customer: (state) => state.customer,
        }),
		logoMobile: function() {
			return window.innerWidth < 768;
		},
    },
    methods: {
        goBack() {
            setTimeout(function () {
                this.$router.push({name: 'welcome'});
            }, 100);
        },
        next() {
            this.trackEligibility();
            window.location.href='tel:*1056';
        },
        async trackEligibility() {
			await trackEvent.track({
				user: {
					login: this.customer.login,
					loginType: '',
					lineType: this.customer.loginType,
					segment: this.customer.segment,
					subSegment: this.customer.subSegment,
					planCode: this.customer.planCode,
					planName: this.customer.planName,
				},
				channel: trackEvent.getChannel(),
				'event-category': 6,
				'event-action': 2,
				'event-label': `Troca de Chip Erro Ex Oi Elegibilidade Tentativa 3`,
				'event-value': null,
				'event-status': 'Sucesso',
				'event-interactionNumber': '',
				'event-error': '',
				'event-errorDetail': '',
			})
		},
    }
};
</script>

<style lang="scss" scoped>
    .call-tim {
        width: 100%;
        height: 100%;
        display: block;
        position: fixed;
        z-index: -1;
        overflow-y: auto;
        .bt_no_click {
            z-index: -1;
        }
    }

    .call-tim-body {
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .call-tim-informations {
        width: 100%;
        display: block;
    }
    .call-tim-informations > img {
        width: 60px !important;
        height: 60px !important;
        display: block;
        margin: 0 auto 37px auto;
    }
    .call-tim-informations > h4 {
        width: 258px;
        height: auto;
        display: block;
        margin: 0 auto 24px auto;
        font-family: timsans_regular;
        font-size: 2em;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
    }
    .call-tim-informations > p {
        width: 240px;
        height: auto;
        display: block;
        margin: 0 auto 40px auto;
        font-family: timsans_regular;
        font-size: 1em;
        line-height: 1.5;
        letter-spacing: -0.2px;
        text-align: center;
        color: #000000;
        opacity: 0.6;
    }

    .call-tim-button .btn {
        width: 80vw;
        max-width: 500px;
    }
</style>
